var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VLayout",
    [
      _c("VFlex", [
        _c(
          "div",
          {
            class: [
              "password-component",
              _vm.showCriteria ? "show-criteria" : ""
            ]
          },
          [
            _c(
              "VTextField",
              {
                ref: "password",
                staticClass: "flex-column password-field",
                attrs: {
                  maxlength: "72",
                  "data-testid": _vm.testid,
                  "append-icon": _vm.showPassword ? "show" : "hide",
                  rules: _vm.passwordRules,
                  type: _vm.showPassword ? "text" : "password",
                  username: _vm.username,
                  "persistant-hint": _vm.warning,
                  hint: _vm.warning ? _vm.txc.usernameCantBePassword : "",
                  autocomplete: "new-password",
                  "validate-on-blur": _vm.validateOnBlur,
                  required: ""
                },
                on: {
                  input: _vm.onInput,
                  focus: _vm.onFocus,
                  blur: _vm.onBlur
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              },
              [
                _c("template", { slot: "label" }, [
                  _c("span", { staticClass: "field-label" }, [
                    _vm._v(_vm._s(_vm.txc.newPassword))
                  ])
                ]),
                _vm._v(" "),
                _c("template", { slot: "append" }, [
                  _c(
                    "span",
                    {
                      staticClass: "field-append-label",
                      on: {
                        click: function($event) {
                          _vm.showPassword = !_vm.showPassword
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.showPassword ? _vm.txc.hide : _vm.txc.show
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.criteriaBlock && !_vm.warning,
                    expression: "criteriaBlock && !warning"
                  }
                ],
                staticClass: "criteria-block"
              },
              [
                _c("ul", [
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.criteriaComplete,
                          expression: "!criteriaComplete"
                        }
                      ],
                      class: { completed: _vm.includes8chars }
                    },
                    [
                      !_vm.includes8chars
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-close-x" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.includes8chars
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-checkmark" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.txc.includes8chars))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.criteriaComplete,
                          expression: "!criteriaComplete"
                        }
                      ],
                      class: { completed: _vm.includesUpper }
                    },
                    [
                      !_vm.includesUpper
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-close-x" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.includesUpper
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-checkmark" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.txc.includesUpper))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.criteriaComplete,
                          expression: "!criteriaComplete"
                        }
                      ],
                      class: { completed: _vm.includesLower }
                    },
                    [
                      !_vm.includesLower
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-close-x" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.includesLower
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-checkmark" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.txc.includesLower))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.criteriaComplete,
                          expression: "!criteriaComplete"
                        }
                      ],
                      class: { completed: _vm.includesNumber }
                    },
                    [
                      !_vm.includesNumber
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-close-x" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.includesNumber
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-checkmark" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.txc.includesNumber))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.criteriaComplete,
                          expression: "!criteriaComplete"
                        }
                      ],
                      class: { completed: _vm.includesSpecialChars }
                    },
                    [
                      !_vm.includesSpecialChars
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-close-x" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.includesSpecialChars
                        ? _c("NsIcon", {
                            staticStyle: { width: "18px", height: "18px" },
                            attrs: { "icon-name": "icon-checkmark" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.txc.includesSpecialChars))])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.criteriaComplete,
                        expression: "criteriaComplete"
                      }
                    ],
                    staticClass: "criteria-complete"
                  },
                  [
                    _c(
                      "li",
                      { staticClass: "completed" },
                      [
                        _c("NsIcon", {
                          staticStyle: { width: "18px", height: "18px" },
                          attrs: { "icon-name": "icon-checkmark" }
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.txc.criteriaComplete))])
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }